import { Action, createReducer, on } from '@ngrx/store';
import { initialize, setDebug, setOnlineStatus } from './core.actions';

export interface State {
  shipParameter: string;
  online: boolean;
  isDebug: boolean;
}

export const initalState: State = {
  shipParameter: '',
  online: true,
  isDebug: false,
};

export const reducerFn = createReducer(
  initalState,
  on(initialize, (state, { name: shipParameter }): State => {
    return { ...state, shipParameter };
  }),
  on(setOnlineStatus, (state, { online }): State => {
    return { ...state, online };
  }),
  on(setDebug, (state, { isDebug }): State => {
    return { ...state, isDebug };
  })
);

export function reducer(state = initalState, action: Action): State {
  return reducerFn(state, action);
}

export const featureName = 'core';
